const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
};

const registryService = {
  async listRegistries() {
    const res = await fetch(`${API_URL}/settings/registries`, { headers: getAuthHeaders() });
    return res.json();
  },

  async createRegistry(data) {
    const res = await fetch(`${API_URL}/settings/registries`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    return res.json();
  },

  async updateRegistry(id, data) {
    const res = await fetch(`${API_URL}/settings/registries/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    return res.json();
  },

  async deleteRegistry(id) {
    const res = await fetch(`${API_URL}/settings/registries/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return res.json();
  },

  async browseRepositories(registryId) {
    const res = await fetch(`${API_URL}/settings/registries/${registryId}/repositories`, {
      headers: getAuthHeaders()
    });
    return res.json();
  },

  async browseTags(registryId, repoPath) {
    const res = await fetch(`${API_URL}/settings/registries/${registryId}/tags/${encodeURIComponent(repoPath)}`, {
      headers: getAuthHeaders()
    });
    return res.json();
  }
};

export default registryService;
